import React from 'react';
import './Phase.scss';
export default ({ isActive, phase, parts, studyLength, title, position, utm }) => {
  const steps = [
    { icon: 'people', title: 'Number of Participants', copy: `Usually ${parts}`},
    { icon: 'calendar', title: 'Length of Study', copy: studyLength}
  ]

  return (
    <div className="phase-container">
      <div className={`phase ${position ? position : ''}`}>
        <div className="title">
          <h1 className="capitalize">{`Phase ${phase}`}</h1>
          <p>{title}</p>
        </div>
        <div className="step-container">
          {steps && steps.map((step, i) => {
              return (
                <div className={`step ${step.icon}`}>
                  <div className={`icon ${step.icon}`}></div>
                  <div className="copy-container">
                    <p className="step-title">{step.title}</p>
                    <p className="copy">{`${step.copy}`}</p>
                  </div>
                </div>
              )
            })}
        </div>
        <div className="phase-cta">
          <a href={`${utm}`} target="_blank">Learn More About Clinical Trials</a>
        </div>
      </div>
    </div>
  );
};